import type {
  IAssistantShare,
  IAssistantSharesListResponse,
  IShareAssistantPayload,
  IUpdateAssistantSharePayload,
} from "../types";
import type { ApiClient } from "./client";

export class AssistantSharesApi {
  constructor(private readonly apiClient: ApiClient) {}

  async share(
    assistantUuid: string,
    data: IShareAssistantPayload,
  ): Promise<IAssistantShare[]> {
    const response = await this.apiClient.post<IAssistantShare[]>(
      `/assistants/${assistantUuid}/shares`,
      data,
    );
    return response.data;
  }

  async getShares(
    assistantUuid: string,
  ): Promise<IAssistantSharesListResponse> {
    const response = await this.apiClient.get<IAssistantSharesListResponse>(
      `/assistants/${assistantUuid}/shares`,
    );
    return response.data;
  }

  async updateShare(
    assistantUuid: string,
    shareUuid: string,
    data: IUpdateAssistantSharePayload,
  ): Promise<IAssistantShare> {
    const response = await this.apiClient.put<IAssistantShare>(
      `/assistants/${assistantUuid}/shares/${shareUuid}`,
      data,
    );
    return response.data;
  }

  async removeShare(assistantUuid: string, shareUuid: string): Promise<void> {
    await this.apiClient.delete(
      `/assistants/${assistantUuid}/shares/${shareUuid}`,
    );
  }
}
